export default "__VITE_ASSET__936c658a__"